export interface Task {
  woid: string;
  name: string;
  days_left: string;
  status: string;
  priority: string;
  wotype: string;
  customer_name: string;
  contract_number: string;
  address_details: string;
  start_date: string;
  end_date: string;
  visible: boolean;
  bookmark: boolean;
  created_date: string;
  updated_date: string;
  seen: string;
  chain: string;
  userid: string;
  selected: boolean;
  new_item: boolean;
  notif: boolean;
  assignee: string;
  teams: string;
  interval: string;
  created_by: string;
  lines_no: string;
  days_left_label: string;
  days_left_value: string;
  days_left_class: string;
  status_class: string;
  priority_class: string;
  bookmark_class: boolean;
  no_assignee: boolean;
  actions: string[];
  quick_actions: string[];
  open_action: string;
}

export interface TaskDuration {
  activityType: TaskActivityType;
  duration: number;
}

export enum TaskActivityType {
  General = 'General Activity',
  Inspection = 'Inspection Activity',
  Labor = 'Labor Activity',
  Other = 'Other Activity',
  Travel = 'Travel Activity',
  Vendor = 'Vendor Activity',
}
